// useResetOnOpen — the reseed-on-open contract of every overlay that stays mounted between opens (a drawer, a dialog):
// `onChange(open)` runs during render on each open/close transition, so a host seeds its draft from the current read
// on open and clears its transient state on close. React's "adjust state on a prop change" shape (the previous value
// kept beside it) — never an effect, so no stale intermediate paint, and a background refetch while the overlay is
// open never clobbers the draft (only a transition reseeds).

import { useState } from 'react';

export function useResetOnOpen(open: boolean, onChange: (open: boolean) => void): void {
  const [wasOpen, setWasOpen] = useState(open);
  if (open !== wasOpen) {
    setWasOpen(open);
    onChange(open);
  }
}
